import { ContentCard } from '../CMS/ContentCard/ContentCard'

const FeatureBanners = props => {
  const { systemCode, innerElements} = props
  return (
    <div className={`feature-banners ${systemCode}`}>
        {innerElements.map((banner, i) => {
            return <ContentCard key={i} {...banner} />
            // return <BandSlide key={slide.brandID} {...slide} />
        })}
    </div>
  )
}

export { FeatureBanners }
